import { getStripeCustomerID } from '../../data/stripe/customer'
import getFQDN from '../rest'
import LOG from '../../logging/Logger'

export async function createBillingPortalSession(handleSubscriptionError) {
  try {
    const customerId = await getStripeCustomerID(handleSubscriptionError)
    LOG.debug('pre customerId:', customerId)

    if (customerId) {
      const createSessionResult = await fetch(
        getFQDN('v1/create-portal-session'),
        {
          method: 'post',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            customer: customerId
          })
        }
      )
      const stripePortalSession = await createSessionResult.json()

      if (stripePortalSession) {
        if (stripePortalSession.error) {
          return handleSubscriptionError(stripePortalSession)
        }
        LOG.debug('stripePortalSession:', stripePortalSession)

        const url = stripePortalSession.billingPortal.url
        LOG.debug('url:', url)
        return url
      }
    }
  } catch (error) {
    LOG.error('createBillingPortalSession error: ', error)
  }
}

export default createBillingPortalSession
